import React from "react";
import Button from "../..//Elements/Button/Button.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { ImagesFromMailGrid } from "./ImagesFromMailGrid.js";
import Icon from "../../Elements/Icon/Icon.tsx";

import "./BrandedCoverUploader.scss";

const SpecificMailBrandedCoverSelector = ({
  setFileId,
  handleClick,
  mailImagesList,
  children,
}) => {
  const { getTextByKey } = useContent();
  const updateSelectedImage = (fileId) => {
    setFileId(fileId);
  };

  return (
    <div className="specific-mail-branded-cover-content-container">
      <div className="specific-mail-branded-cover-content">
        {mailImagesList.length > 0 ? (
          <>
            <div className="specific-mail-branded-cover-subtitle">
              {getTextByKey("specific-mail-cover-select-from-mail-files")}
            </div>
            <ImagesFromMailGrid {...{ mailImagesList, updateSelectedImage }} />
            <div className="horizontal-or-divider">{getTextByKey("or")}</div>
          </>
        ) : null}
        <div className="specific-mail-branded-cover-button">
          <Button onClick={handleClick}>
            {getTextByKey("background-upload-image-button")}
            <Icon name="upload" white />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SpecificMailBrandedCoverSelector;
